import script from "./ImageElementOperate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageElementOperate.vue?vue&type=script&lang=ts&setup=true"

import "./ImageElementOperate.vue?vue&type=style&index=0&id=46b250c2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b250c2"]])

export default __exports__